import { useContext } from 'react';

import FilesDragContext from '../context';
import { DraggedFile } from '../interfaces';

const useDraggedFileContext = (): DraggedFile => useContext<DraggedFile>(FilesDragContext);

export default useDraggedFileContext;
